<div class="acca-boost-carousel-item-connector"></div>
<div class="acca-boost-carousel-factor__wrapper">
    <div class="acca-boost-carousel-factor acca-boost-factor" [class.acca-boost-carousel-factor-enhanced]="isEnhancedLayoutEnabled">
        @if (model.included || model.selected) {
            @if (isEnhancedLayoutEnabled) {
                <vn-icon name="theme-acca-boost" size="12" />
            } @else {
                <vn-icon name="theme-check" class="acca-boost-theme-check" size="11" />
            }
        }
        {{ model.ratio | msAccaBoostRatio: false }}
    </div>
    <span [class.acca-boost-carousel-factor-legs-enhanced]="isEnhancedLayoutEnabled">{{ model.numberOfLegs }} {{ sitecore.accaBoost.Picks }}</span>
</div>
@if (itemCount > 1) {
    <div class="animation-progressing" [class.animation-selected]="model.included"></div>
}
